"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("./Box"));

var _icons = _interopRequireDefault(require("@hackclub/icons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Icon = (0, _styledComponents["default"])(_Box["default"].withComponent(_icons["default"]))(_templateObject());
Icon.displayName = 'Icon';
Icon.propTypes = {
  /** which icon to draw */
  glyph: _propTypes["default"].string,

  /** width/height, numbers in px */
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
Icon.defaultProps = {
  glyph: 'flag',
  size: 24
};
var _default = Icon;
exports["default"] = _default;